import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CompleterService } from 'ng2-completer';
import { GeneralService } from 'src/app/services/general.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { log } from 'console';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {
  @ViewChild('triDeleteModal') triDeleteModal: ElementRef;
  auxUser: any = {};

  users: any[] = [];

  loginUserLoading: boolean = false;

  pageConfig: any = {
    pageNumber: 1,
    pageSize: 25,
    quantity: 0,
    pages: 0,
    filter: '',
    filter_aux: ''
  };

  pages: any = {
    user_list: true,
    edit_user: false
  };

  userSelected: any = {};

  constructor(
    private generalService: GeneralService,
    private renderer: Renderer2,
    private usuarioService: UsuarioService,
    private completerService: CompleterService,
  ) { }

  ngOnInit(): void {
    this.listUsers();
  }

  goToPage(page: number) {
    if (
      !page ||
      page < 1 ||
      page > this.pageConfig.pages ||
      page === this.pageConfig.pageNumber
    ) {
      return;
    }

    this.pageConfig.pageNumber = page;
    this.listUsers();
  }

  getPaginationPages(): any[] {
    const totalPages = Number(this.pageConfig?.pages || 0);
    const currentPage = Number(this.pageConfig?.pageNumber || 1);

    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    // Primeras páginas
    if (currentPage <= 4) {
      return [
        1,
        2,
        3,
        4,
        5,
        '...',
        totalPages
      ];
    }

    // Últimas páginas
    if (currentPage >= totalPages - 3) {
      return [
        1,
        '...',
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      ];
    }

    // Páginas intermedias
    return [
      1,
      '...',
      currentPage - 1,
      currentPage,
      currentPage + 1,
      '...',
      totalPages
    ];
  }


  listUsers() {
    this.users = [];
    this.generalService.modalCargando();
    this.usuarioService.listUsers(this.pageConfig)
      .then((result: any) => {
        this.users = result.users;

        this.pageConfig = result.page;
        this.pageConfig.filter_aux = this.pageConfig.filter;
        // console.log(this.users);
        // console.log(this.pageConfig);
        Swal.close();
      })
      .catch(error => {
        this.generalService.modalError('Error', 'Error al cargar usuarios');
      });
  }

  confirmDelete() {
    if (!this.userSelected.use_id) {
      this.generalService.modalError('Error', 'Error al desactivar usuario');
      return;
    }
    this.generalService.modalCargando();
    this.renderer.selectRootElement(this.triDeleteModal.nativeElement).click();
    this.usuarioService.deleteUser({ use_id: this.userSelected.use_id })
      .then(async (result: any) => {
        this.generalService.modalExitoso('Exito', 'El usuario se ha desactivado con exito.');
        await this.generalService.sleep(1000);
        this.listUsers();
      })
      .catch(error => {
        this.generalService.modalError('Error', 'Error al desactivar usuario');
      });
  }

  deleteUser(user: any) {
    this.userSelected = {};
    if (!user.use_id) {
      this.generalService.modalError('Error', 'Error al desactivar usuario');
      return;
    }
    this.userSelected = user;
    this.renderer.selectRootElement(this.triDeleteModal.nativeElement).click();
    // console.log(this.userSelected);
    

  }

  // changeFea(user: any){
   
  // }

  ListarLoading() {
    this.pageConfig.pageNumber = 1;
    this.pageConfig.pageSize = 25;
    this.pageConfig.filter = this.pageConfig.filter_aux;
    this.listUsers();
  }

  editUser(user: any) {
    // console.log(user);
    user.birth_date = new Date(user.birth_date);
    if (user.egress_date) {
      user.egress_date = new Date(user.egress_date);
    }
    this.auxUser = user;
    this.pages = {
      user_list: false,
      edit_user: true
    };
  }

  private abrirSesionUsuario(
    newWindow: Window,
    url: string,
    session: any
  ) {

    try {

      console.log(
        '[abrirSesionUsuario] URL recibida:',
        url
      );

      console.log(
        '[abrirSesionUsuario] session:',
        session
      );

      const targetUrl = new URL(url);

      const targetOrigin =
        targetUrl.origin;

      const openerOrigin =
        window.location.origin;

      console.log(
        '[abrirSesionUsuario] targetOrigin:',
        targetOrigin
      );

      console.log(
        '[abrirSesionUsuario] openerOrigin:',
        openerOrigin
      );

      // ==========================================
      // ESCUCHAR RESPUESTA DE LA NUEVA VENTANA
      // ==========================================

      const listener = (
        event: MessageEvent
      ) => {

        console.log(
          '[abrirSesionUsuario] Mensaje recibido:',
          event.data
        );

        console.log(
          '[abrirSesionUsuario] origin recibido:',
          event.origin
        );

        if (event.source !== newWindow) {
          console.warn(
            '[abrirSesionUsuario] Ventana origen incorrecta'
          );

          return;
        }

        if (event.origin !== targetOrigin) {
          console.warn(
            '[abrirSesionUsuario] Origin incorrecto'
          );

          return;
        }

        if (
          event.data?.type !==
          'ADMIN_SESSION_READY'
        ) {
          return;
        }

        console.log(
          '[abrirSesionUsuario] AdminSession está listo'
        );

        window.removeEventListener(
          'message',
          listener
        );

        // ==========================================
        // ENVIAR SESIÓN
        // ==========================================

        newWindow.postMessage(
          {
            type: 'ADMIN_SESSION_INIT',
            session
          },
          targetOrigin
        );

        console.log(
          '[abrirSesionUsuario] Sesión enviada'
        );

      };

      window.addEventListener(
        'message',
        listener
      );

      // ==========================================
      // CONSTRUIR URL
      // ==========================================

      /*
      * Parámetro antes del hash.
      *
      * Esto fuerza una carga real del documento
      * Angular y evita que el navegador mantenga
      * el documento about:blank.
      */
      targetUrl.searchParams.set(
        '_adminLogin',
        Date.now().toString()
      );

      /*
      * La API ya entrega:
      *
      * http://localhost:4200/#/admin-session
      */

      let hashRoute =
        targetUrl.hash ||
        '#/admin-session';

      const separator =
        hashRoute.includes('?')
          ? '&'
          : '?';

      hashRoute +=
        `${separator}` +
        `openerOrigin=${encodeURIComponent(openerOrigin)}`;

      targetUrl.hash =
        hashRoute;

      const finalUrl =
        targetUrl.toString();

      console.log(
        '[abrirSesionUsuario] Navegando a:',
        finalUrl
      );

      // ==========================================
      // CARGAR ANGULAR
      // ==========================================

      newWindow.location.replace(
        finalUrl
      );

    } catch (error) {

      console.error(
        '[EditUserComponent][abrirSesionUsuario]',
        error
      );

      newWindow.close();

      this.generalService.modalError(
        'Error',
        'No se pudo abrir la sesión del usuario.'
      );

    }
  }

  loginAsUser(user: any, type: any) {
    if (!user?.use_id || !type?.use_typ_id) {
      this.generalService.modalError(
        'Error',
        'No se pudo identificar el usuario o perfil.'
      );
      return;
    }
    const width = 1400;
    const height = 900;
    const left =
      window.screenX +
      Math.max(0, (window.outerWidth - width) / 2);

    const top =
      window.screenY +
      Math.max(0, (window.outerHeight - height) / 2);

    const windowName =
      `usuario_${user.use_id}_${type.use_typ_id}_${Date.now()}`;

    const newWindow = window.open(
      'about:blank',
      windowName,
      `
        popup=yes,
        width=${width},
        height=${height},
        left=${left},
        top=${top},
        resizable=yes,
        scrollbars=yes
      `.replace(/\s/g, '')
    );

    if (!newWindow) {
      this.generalService.modalError(
        'Error',
        'El navegador bloqueó la nueva ventana. Debe permitir ventanas emergentes para este sitio.'
      );

      return;
    }

    const params = {
      use_id: Number(user.use_id),
      use_typ_id: Number(type.use_typ_id)
    };

    this.usuarioService.loginAsUser(params)
      .then((result: any) => {

        console.log(
          '[loginAsUser] Respuesta:',
          result
        );

        if (
          !result?.success ||
          !result?.url ||
          !result?.session?.token
        ) {

          newWindow.close();

          this.generalService.modalError(
            'Error',
            result?.message ||
            'No fue posible iniciar la sesión.'
          );

          return;
        }

        this.abrirSesionUsuario(
          newWindow,
          result.url,
          result.session
        );

      })
      .catch((error: any) => {

        newWindow.close();

        console.error(
          '[EditUserComponent][loginAsUser]',
          error
        );

        this.generalService.modalError(
          'Error',
          error?.error?.message ||
          'Error al iniciar sesión con el usuario.'
        );

      });
  }
  
  
}
